import trialFilters from './trials';
export default trialFilters;
